import CustomFlagCFD from './CustomFlagCFD';

export default CustomFlagCFD;
